import moment from 'moment';

const getDaysNumberInDuration = (start, end) => {
  const days = [];
  let currentDate = moment(start);

  while (currentDate.valueOf() <= end) {
    days.push(currentDate.date());
    currentDate = currentDate.add(1, 'days');
  }

  return days;
};

const getRandomValue = () => (Math.random() * 10).toFixed(3);

const getFilteredDevicesByChosenDays = (devices, days) =>
  Object.fromEntries(
    Object.entries(devices).map(([key, values]) => {
      const filteredValues = Object.fromEntries(Object.entries(values).filter(([day]) => days.includes(Number(day))));

      return [key, filteredValues];
    }),
  );

export const getMockedPlazaForTheLast30Days = (from, to) => {
  const startDate = moment.utc(from).valueOf();
  const endDate = moment.utc(to).subtract(1, 'days').valueOf();
  const daysOfChosenMonth = getDaysNumberInDuration(startDate, endDate);

  const mockedData = {
    meta: {
      tsFrom: startDate,
      tsTo: endDate,
      interval: '1day',
      chargerUuids: ['IOT00141648D9837B01', 'IOT00141648D9713301', 'IOT00141648D980C601', 'IOT00141648D9716C01', 'IOT00141648D9716201'],
      type: 'sum',
    },
    devices: {
      IOT00141648D9837B01: {
        1: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(1).valueOf(),
          value: 45.368521944444446,
          measure: 'DELIVERED_ENERGY',
        },
        2: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(2).valueOf(),
          value: 19.310306111111114,
          measure: 'DELIVERED_ENERGY',
        },
        3: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(3).valueOf(),
          value: 33.399925,
          measure: 'DELIVERED_ENERGY',
        },
        4: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(4).valueOf(),
          value: 27.744787499999997,
          measure: 'DELIVERED_ENERGY',
        },
        5: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(5).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        6: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(6).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        7: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(7).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        8: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(8).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        9: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(9).valueOf(),
          value: 38.25031888888889,
          measure: 'DELIVERED_ENERGY',
        },
        10: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(10).valueOf(),
          value: 8.514303055555557,
          measure: 'DELIVERED_ENERGY',
        },
        11: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(11).valueOf(),
          value: 21.839090833333334,
          measure: 'DELIVERED_ENERGY',
        },
        12: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(12).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        13: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(13).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        14: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(14).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        15: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(15).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        16: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(16).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        17: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(17).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        18: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(18).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        19: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(19).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        20: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(20).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        21: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(21).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        22: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(22).valueOf(),
          value: 6.612340555555556,
          measure: 'DELIVERED_ENERGY',
        },
        23: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(23).valueOf(),
          value: 12.539971944444444,
          measure: 'DELIVERED_ENERGY',
        },
        24: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(24).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        25: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(25).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        26: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(26).valueOf(),
          value: 10.145709166666668,
          measure: 'DELIVERED_ENERGY',
        },
        27: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(27).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        28: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(28).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        29: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(29).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        30: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(30).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        31: {
          chargerUuid: 'IOT00141648D9837B01',
          ts: moment(startDate).date(31).valueOf(),
          value: 16.965053333333334,
          measure: 'DELIVERED_ENERGY',
        },
      },
      IOT00141648D9713301: {
        1: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(1).valueOf(),
          value: 26.182152777777777,
          measure: 'DELIVERED_ENERGY',
        },
        2: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(2).valueOf(),
          value: 22.186363888888888,
          measure: 'DELIVERED_ENERGY',
        },
        3: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(3).valueOf(),
          value: 7.304986111111111,
          measure: 'DELIVERED_ENERGY',
        },
        4: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(4).valueOf(),
          value: 37.14604444444444,
          measure: 'DELIVERED_ENERGY',
        },
        5: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(5).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        6: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(6).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        7: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(7).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        8: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(8).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        9: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(9).valueOf(),
          value: 28.93541666666667,
          measure: 'DELIVERED_ENERGY',
        },
        10: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(10).valueOf(),
          value: 5.611111111111111e-4,
          measure: 'DELIVERED_ENERGY',
        },
        11: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(11).valueOf(),
          value: 31.964530555555555,
          measure: 'DELIVERED_ENERGY',
        },
        12: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(12).valueOf(),
          value: 41.30128333333333,
          measure: 'DELIVERED_ENERGY',
        },
        13: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(13).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        14: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(14).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        15: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(15).valueOf(),
          value: 39.62195277777778,
          measure: 'DELIVERED_ENERGY',
        },
        16: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(16).valueOf(),
          value: 27.51741666666667,
          measure: 'DELIVERED_ENERGY',
        },
        17: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(17).valueOf(),
          value: 15.895686111111111,
          measure: 'DELIVERED_ENERGY',
        },
        18: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(18).valueOf(),
          value: 15.913616666666666,
          measure: 'DELIVERED_ENERGY',
        },
        19: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(19).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        20: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(20).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        21: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(21).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        22: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(22).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        23: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(23).valueOf(),
          value: 34.76500277777778,
          measure: 'DELIVERED_ENERGY',
        },
        24: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(24).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        25: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(25).valueOf(),
          value: 10.096797222222222,
          measure: 'DELIVERED_ENERGY',
        },
        26: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(26).valueOf(),
          value: 7.119952777777778,
          measure: 'DELIVERED_ENERGY',
        },
        27: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(27).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        28: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(28).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        29: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(29).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        30: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(30).valueOf(),
          value: 23.08326388888889,
          measure: 'DELIVERED_ENERGY',
        },
        31: {
          chargerUuid: 'IOT00141648D9713301',
          ts: moment(startDate).date(31).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
      },
      IOT00141648D980C601: {
        1: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(1).valueOf(),
          value: 24.717212500000002,
          measure: 'DELIVERED_ENERGY',
        },
        2: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(2).valueOf(),
          value: 32.36738444444445,
          measure: 'DELIVERED_ENERGY',
        },
        3: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(3).valueOf(),
          value: 44.99173444444445,
          measure: 'DELIVERED_ENERGY',
        },
        4: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(4).valueOf(),
          value: 0.04262805555555556,
          measure: 'DELIVERED_ENERGY',
        },
        5: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(5).valueOf(),
          value: 9.84973138888889,
          measure: 'DELIVERED_ENERGY',
        },
        6: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(6).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        7: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(7).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        8: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(8).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        9: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(9).valueOf(),
          value: 11.51685,
          measure: 'DELIVERED_ENERGY',
        },
        10: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(10).valueOf(),
          value: 11.41565,
          measure: 'DELIVERED_ENERGY',
        },
        11: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(11).valueOf(),
          value: 32.257440555555554,
          measure: 'DELIVERED_ENERGY',
        },
        12: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(12).valueOf(),
          value: 54.22032472222222,
          measure: 'DELIVERED_ENERGY',
        },
        13: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(13).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        14: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(14).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        15: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(15).valueOf(),
          value: 32.5162375,
          measure: 'DELIVERED_ENERGY',
        },
        16: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(16).valueOf(),
          value: 11.8375625,
          measure: 'DELIVERED_ENERGY',
        },
        17: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(17).valueOf(),
          value: 11.434859444444445,
          measure: 'DELIVERED_ENERGY',
        },
        18: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(18).valueOf(),
          value: 31.90905,
          measure: 'DELIVERED_ENERGY',
        },
        19: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(19).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        20: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(20).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        21: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(21).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        22: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(22).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        23: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(23).valueOf(),
          value: 20.58694361111111,
          measure: 'DELIVERED_ENERGY',
        },
        24: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(24).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        25: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(25).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        26: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(26).valueOf(),
          value: 26.274381388888887,
          measure: 'DELIVERED_ENERGY',
        },
        27: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(27).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        28: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(28).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        29: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(29).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        30: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(30).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        31: {
          chargerUuid: 'IOT00141648D980C601',
          ts: moment(startDate).date(31).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
      },
      IOT00141648D9716C01: {
        1: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(1).valueOf(),
          value: 12.732128055555554,
          measure: 'DELIVERED_ENERGY',
        },
        2: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(2).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        3: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(3).valueOf(),
          value: 7.552640833333333,
          measure: 'DELIVERED_ENERGY',
        },
        4: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(4).valueOf(),
          value: 19.13102166666667,
          measure: 'DELIVERED_ENERGY',
        },
        5: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(5).valueOf(),
          value: 20.86613138888889,
          measure: 'DELIVERED_ENERGY',
        },
        6: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(6).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        7: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(7).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        8: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(8).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        9: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(9).valueOf(),
          value: 33.6772625,
          measure: 'DELIVERED_ENERGY',
        },
        10: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(10).valueOf(),
          value: 50.823771944444445,
          measure: 'DELIVERED_ENERGY',
        },
        11: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(11).valueOf(),
          value: 11.677484444444444,
          measure: 'DELIVERED_ENERGY',
        },
        12: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(12).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        13: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(13).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        14: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(14).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        15: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(15).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        16: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(16).valueOf(),
          value: 11.682840555555556,
          measure: 'DELIVERED_ENERGY',
        },
        17: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(17).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        18: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(18).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        19: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(19).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        20: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(20).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        21: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(21).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        22: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(22).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        23: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(23).valueOf(),
          value: 17.30261888888889,
          measure: 'DELIVERED_ENERGY',
        },
        24: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(24).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        25: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(25).valueOf(),
          value: 29.937412499999997,
          measure: 'DELIVERED_ENERGY',
        },
        26: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(26).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        27: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(27).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        28: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(28).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        29: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(29).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        30: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(30).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        31: {
          chargerUuid: 'IOT00141648D9716C01',
          ts: moment(startDate).date(31).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
      },
      IOT00141648D9716201: {
        1: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(1).valueOf(),
          value: 36.8241875,
          measure: 'DELIVERED_ENERGY',
        },
        2: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(2).valueOf(),
          value: 16.959962500000003,
          measure: 'DELIVERED_ENERGY',
        },
        3: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(3).valueOf(),
          value: 6.686111111111111e-4,
          measure: 'DELIVERED_ENERGY',
        },
        4: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(4).valueOf(),
          value: 11.9189625,
          measure: 'DELIVERED_ENERGY',
        },
        5: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(5).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        6: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(6).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        7: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(7).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        8: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(8).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        9: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(9).valueOf(),
          value: 14.777771944444444,
          measure: 'DELIVERED_ENERGY',
        },
        10: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(10).valueOf(),
          value: 3.8606655555555554,
          measure: 'DELIVERED_ENERGY',
        },
        11: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(11).valueOf(),
          value: 7.5e-4,
          measure: 'DELIVERED_ENERGY',
        },
        12: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(12).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        13: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(13).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        14: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(14).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        15: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(15).valueOf(),
          value: 4.617771944444445,
          measure: 'DELIVERED_ENERGY',
        },
        16: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(16).valueOf(),
          value: 48.2891,
          measure: 'DELIVERED_ENERGY',
        },
        17: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(17).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        18: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(18).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        19: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(19).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        20: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(20).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        21: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(21).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        22: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(22).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        23: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(23).valueOf(),
          value: 17.501743611111113,
          measure: 'DELIVERED_ENERGY',
        },
        24: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(24).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        25: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(25).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        26: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(26).valueOf(),
          value: 42.26250638888889,
          measure: 'DELIVERED_ENERGY',
        },
        27: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(27).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        28: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(28).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        29: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(29).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        30: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(30).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
        31: {
          chargerUuid: 'IOT00141648D9716201',
          ts: moment(startDate).date(31).valueOf(),
          value: 0.0,
          measure: 'DELIVERED_ENERGY',
        },
      },
    },
  };

  const filteredDevices = getFilteredDevicesByChosenDays(mockedData.devices, daysOfChosenMonth);

  return {
    ...mockedData,
    devices: filteredDevices,
  };
};

const barValuesMap = {
  IOT00141648D9837B01: {
    from: 9,
    to: 18,
  },
  IOT00141648D9713301: {
    from: 7,
    to: 12,
  },
  IOT00141648D980C601: {
    from: 8,
    to: 15,
  },
  IOT00141648D9716C01: {
    from: 9,
    to: 12,
  },
  IOT00141648D9716201: {
    from: 8,
    to: 18,
  },
};

const generateDeviceData = (startDate, chargerUuid) => {
  const deviceData = {};
  const HOURS_AMOUNT = 24;

  for (let hour = 1; hour <= HOURS_AMOUNT; hour++) {
    deviceData[hour] = {
      chargerUuid,
      ts: moment(startDate)
        .add(hour - 1, 'hours')
        .valueOf(),
      value: hour >= barValuesMap[chargerUuid].from && hour <= barValuesMap[chargerUuid].to ? getRandomValue() : 0,
      measure: 'DELIVERED_ENERGY',
    };
  }

  return deviceData;
};

const mockedBar = (startDate) => ({
  meta: {
    tsFrom: startDate,
    tsTo: moment(startDate).utc().add(1, 'days').valueOf(),
    interval: '1hour',
    chargerUuids: ['IOT00141648D9837B01', 'IOT00141648D9713301', 'IOT00141648D980C601', 'IOT00141648D9716C01', 'IOT00141648D9716201'],
    type: 'sum',
  },
  devices: {
    IOT00141648D9837B01: generateDeviceData(startDate, 'IOT00141648D9837B01'),
    IOT00141648D9713301: generateDeviceData(startDate, 'IOT00141648D9713301'),
    IOT00141648D980C601: generateDeviceData(startDate, 'IOT00141648D980C601'),
    IOT00141648D9716C01: generateDeviceData(startDate, 'IOT00141648D9716C01'),
    IOT00141648D9716201: generateDeviceData(startDate, 'IOT00141648D9716201'),
  },
});

export const getMockedBarsPerHour = (currentTimestamp, selectedDemoChargers) => {
  const startDate = moment(currentTimestamp).utc().valueOf();
  const { meta, devices } = mockedBar(startDate);
  const filteredDevices = selectedDemoChargers.reduce(
    (acc, curr) => ({
      ...acc,
      [curr]: devices[curr],
    }),
    {},
  );

  return {
    meta,
    devices: filteredDevices,
  };
};

export const mockedPlazaList = {
  totalSize: 2,
  payloads: [
    {
      uuid: '5f829ccf-ba45-43a9-9e4f-629eef0cf753',
      name: 'Demo Plaza Oct 21',
      country: 'US',
      address: 'Los Angeles, CA, USA',
      chargerCount: 2,
      plazaStatus: 'ACTIVE',
      hidden: null,
      greengrass: false,
    },
    {
      uuid: '9a21ed4b-5099-4161-9cd8-0e6a4f36ca69',
      name: 'An IoT.ON Edge Plaza',
      country: 'FR',
      address: 'Paris, France',
      chargerCount: 6,
      plazaStatus: 'ACTIVE',
      hidden: false,
      greengrass: false,
    },
    {
      uuid: 'e71c4cbb-6a9d-4950-ace3-e95d01493126',
      name: 'test 1212121212',
      country: 'FR',
      address: "132 Boulevard de l'Europe, 67210 Obernai, France",
      chargerCount: 5,
      plazaStatus: 'ACTIVE',
      hidden: false,
      greengrass: false,
    },
  ],
};

export const getMockedSessions = ({ plaza_uuid, end_time_from, start_time_to, c_uuids }) => {
  const generateRandomSession = (c_uuid) => {
    const randomEnergy = (Math.random() * 10).toFixed(1);
    const startTime = moment.utc(+end_time_from).valueOf();
    const endTime = moment.utc(+start_time_to).valueOf();
    const randomAvgOutputVoltage = (Math.random() * 50 + 200).toFixed(1);
    const randomAvgOutputCurrent = (Math.random() * 50).toFixed(1);

    return {
      connector_id: 1,
      cs_status: 'LOCAL_STOP',
      ev_id: '02AB02F63C70',
      energy: parseFloat(randomEnergy),
      duration: '1',
      end_time: endTime,
      session_id: Math.floor(Math.random() * 10e10),
      c_uuid,
      start_time: startTime,
      charge_mode: 'NORMAL',
      id_tag: null,
      session_type: 'ISO_ED1_AC',
      charger_name: `demo ${c_uuid.slice(-3)}`,
      connector_name: 'Connector 1',
      uuid: plaza_uuid,
      vendor: {
        'MAC address': '00:50:56:c0:00:01',
        ev_operation: 'CHARGING',
      },
      battery_start_prct: null,
      battery_end_prct: null,
      battery_start_charge: null,
      battery_end_charge: null,
      battery_capacity: null,
      avg_output_voltage: parseFloat(randomAvgOutputVoltage),
      avg_output_current: parseFloat(randomAvgOutputCurrent),
    };
  };

  const mockedSessions = c_uuids.map((c_uuid) => generateRandomSession(c_uuid));

  return {
    total_size: c_uuids.length,
    payloads: mockedSessions,
  };
};
